import { SvelteMap } from "svelte/reactivity";
const storageKeyPrefix = "sns_functions_";
export class SnsFunctions {
    _functionsMap;
    // Everything cached in localStorage is loaded up front so that `get` stays pure - it is called
    // from within a derived store and must not read storage or write reactive state.
    constructor() {
        this._functionsMap = new SvelteMap();
        this.fromStorage();
    }
    get(snsCanisterId) {
        return this._functionsMap.get(snsCanisterId);
    }
    set(snsCanisterId, list) {
        const functions = new Map(list.map((f) => [f.id, f]));
        this._functionsMap.set(snsCanisterId, functions);
        this.toStorage(snsCanisterId);
    }
    fromStorage() {
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key === null || !key.startsWith(storageKeyPrefix))
                continue;
            const json = localStorage.getItem(key);
            if (json === null)
                continue;
            try {
                this._functionsMap.set(key.slice(storageKeyPrefix.length), new Map(JSON.parse(json)));
            }
            catch {
                // ignore anything we can't parse - it will be refreshed from the governance canister
            }
        }
    }
    toStorage(snsCanisterId) {
        const functions = this._functionsMap.get(snsCanisterId);
        if (functions === undefined) {
            return;
        }
        localStorage.setItem(storageKeyPrefix + snsCanisterId, JSON.stringify([...functions]));
    }
}
